import { render, staticRenderFns } from "./a-nueva-version.vue?vue&type=template&id=50de767f&scoped=true&"
import script from "./a-nueva-version.vue?vue&type=script&lang=ts&"
export * from "./a-nueva-version.vue?vue&type=script&lang=ts&"
import style0 from "./a-nueva-version.vue?vue&type=style&index=0&id=50de767f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de767f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
